import { AxiosError } from 'axios';
import type { ApiError } from './types';

/**
 * Достаёт человеко-читаемое сообщение из ошибки axios или произвольной.
 * Покрывает три кейса:
 * 1) FastAPI HTTPException → detail: "Email уже зарегистрирован"
 * 2) FastAPI ValidationError → detail: [{ loc, msg, type }]
 * 3) Сетевая ошибка / таймаут — fallback на стандартное сообщение
 */
export function extractErrorMessage(error: unknown, fallback = 'Что-то пошло не так'): string {
  if (error instanceof AxiosError) {
    if (!error.response) {
      // Сеть, таймаут, CORS
      if (error.code === 'ECONNABORTED') {
        return 'Сервер не отвечает. Попробуйте ещё раз.';
      }
      return 'Нет связи с сервером. Проверьте подключение.';
    }

    const data = error.response.data as ApiError | undefined;
    if (data?.detail) {
      if (typeof data.detail === 'string') {
        return data.detail;
      }
      if (Array.isArray(data.detail) && data.detail[0]?.msg) {
        return data.detail[0].msg;
      }
    }

    // HTTP-код без detail
    return `Ошибка ${error.response.status}`;
  }

  if (error instanceof Error) {
    return error.message || fallback;
  }

  return fallback;
}
